/* eslint-disable react/no-danger */
import classNames from 'classnames/bind';
import * as _ from 'lodash-es';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import styles from '../../styles.module.scss';
import chevronDown from '../../../../../images/home/chevron-down.png?as=webp';
import chevronLeft from '../../../../../images/home/chevron-left.png?as=webp';

const cx = classNames.bind(styles);

const SportFaqs = ({ faq }) => {
  const [collapse, setCollapse] = useState([]);

  const faqLength = faq.length;
  return (
    <div className={cx('container', 'detailInfo')}>
      <h1 className={cx('fancyText', 'mt-5')}>Frequently Asked Questions</h1>
      <div className={cx('faqs', 'row')}>
        {_.chunk(faq, Math.ceil(faqLength / 2)).map((chunk, c) => (
          <div className="col-12 col-md-6 mt-4" key={chunk?.[0]?.question}>
            {chunk.map(({ question, answer }, i) => {
              if (!question || !answer) return <div />;
              const idx = i + Math.ceil(faqLength / 2) * c;
              // probably a better way to do this math... ¯\_(ツ)_/¯
              return (
                <div className={cx('card')} key={idx}>
                  <h3>{question}</h3>
                  <img
                    className={cx('arrow')}
                    onClick={() =>
                      collapse.includes(idx)
                        ? setCollapse(collapse.filter(cIdx => cIdx !== idx))
                        : setCollapse([...collapse, idx])
                    }
                    height="40px"
                    src={collapse.includes(idx) ? chevronDown : chevronLeft}
                    alt="toggle collapse faq"
                  />
                  {collapse.includes(idx) && <p dangerouslySetInnerHTML={{ __html: answer }} />}
                </div>
              );
            })}
          </div>
        ))}
        {!faqLength && <div className="ml-3">Coming soon...</div>}
      </div>
    </div>
  );
};

SportFaqs.propTypes = {
  faq: PropTypes.arrayOf(
    PropTypes.shape({
      question: PropTypes.string,
      answer: PropTypes.string,
    })
  ).isRequired,
};

export default SportFaqs;
